import React from "react";
import SportCode from "components/common/SportCode";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";


export function ScoreContainer(props) {
  const { resultObj } = props;
  const { mirs_discipline } = useUrlFriendlyToParameters()
  const result = resultObj?.result;
  const cols = resultObj?.hasIRM ? 'col-6' : 'col'
  const resultType = resultObj?.extra?.resultType
  const qualificationMark = resultObj?.extra?.qualificationMark

  return (
    <div className='w-40 d-flex justify-content-end align-self-center'>
      <div className={` ${resultObj?.rCn ? resultObj?.rCn : 'fw-bold'} p-0 text-end `}>
        {resultType === 'IRM' // hasIRM not valid beacuse is defined for H2H events 
          ? <SportCode discipline={mirs_discipline} code={resultObj?.irm} entity="@IRM" abbr={true} />
          : (resultType === 'FAULT' && resultObj?.irm === 'RAL')
            ? <SportCode discipline="CSL" code={resultObj?.irm} entity="@IRM" abbr={true} />
            : result
        }
        {qualificationMark &&
          <span className="ps-1"><SportCode discipline="CSL" code={qualificationMark} entity="@QualificationMark" abbr={true} /></span>
        }
      </div>
    </div>
  )
}

export default ScoreContainer